<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M35.2898 12.7C32.3898 9.8 28.4098 8 23.9898 8C15.1498 8 8.00977 15.16 8.00977 24C8.00977 32.84 15.1498 40 23.9898 40C31.4498 40 37.6698 34.9 39.4498 28H35.2898C33.6498 32.66 29.2098 36 23.9898 36C17.3698 36 11.9898 30.62 11.9898 24C11.9898 17.38 17.3698 12 23.9898 12C27.3098 12 30.2698 13.38 32.4298 15.56L25.9898 22H39.9898V8L35.2898 12.7Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
